import {
  Box,
  Button,
  FormHelperText,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import imageCompression from "browser-image-compression";
import axios from "axios";
import { SUBMIT_FARM_VISIT_FORM } from "../../constants";
import DeleteIcon from "@mui/icons-material/Delete";

function FarmVisitFormComponent({
  farmList,
  setOpenTaskDialog,
  fetchDailyTasks,
  bdmLeadActionId,
  setOpenSnackbar,
  setMessage,
  setSeverity,
}) {
  const [selectedFarm, setSelectedFarm] = useState({ id: "", name: "" });

  const [remark, setRemark] = useState("");
  const [remarkError, setRemarkError] = useState("");
  const [loadingMandatory, setLoadingMandatory] = useState(false);
  const [visitpictureMandatory, setVisitPictureMandatory] = useState(null);
  const [isTravelSubmitting, setIsTravelSubmitting] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loadingOptional, setLoadingOptional] = useState(false);
  const [travelPictureOptional, setTravelPictureOptional] = useState(null);
  const [previewOptionalUrl, setPreviewOptionalUrl] = useState(null);

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("employeeId", localStorage.getItem("username"));
    formData.append("bdmLeadActionId", bdmLeadActionId);
    formData.append("specificAction", "Farm Visit");
    formData.append("farmId", selectedFarm.id);
    formData.append("farmName", selectedFarm.name);
    formData.append("observation", remark);
    formData.append("mandatoryVisitImage", visitpictureMandatory);

    if( travelPictureOptional ) {
      formData.append("optionalVisitImage", travelPictureOptional); 
    }

    setIsTravelSubmitting(true);
    try {
      const response = await axios.post(`${SUBMIT_FARM_VISIT_FORM}`, formData);
      console.log(response.data);
      setOpenSnackbar(true);
      setMessage(response.data.message);
      setSeverity("success");
      setOpenTaskDialog(false);
      fetchDailyTasks();
    } catch (error) {
      console.log("Error submitting tasks.", error);
      setSeverity("error");
      setMessage("Error submitting tasks. Please try again.");
      setOpenSnackbar(true);
      //   const backendErrors = error?.response?.data?.errors || [];
      //   const errorMap = {};
      //   backendErrors.forEach((err) => {
      //     if (err.field && err.message) {
      //       errorMap[err.field] = err.message;
      //     }
      //   });
      //   setFormErrors(errorMap);
    } finally {
      setIsTravelSubmitting(false);
    }
  };

  return (
    <>
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12}>
          <TextField
            select
            fullWidth
            label="Select Farm"
            value={selectedFarm.id}
            onChange={(e) => {
              const farm = farmList.find((f) => f.FarmId === e.target.value);
              setSelectedFarm({ id: farm.FarmId, name: farm.FarmName });
            }}
          >
            {farmList.map((p) => (
              <MenuItem
                key={p.FarmId}
                value={p.FarmId}
                sx={{
                  borderBottom: "thin solid rgba(0, 0, 0, 0.12)",
                  marginBottom: "8px",
                  marginTop: "8px",
                }}
              >
                {p.FarmName}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="Observation"
            value={remark}
            onChange={(e) => {
              const value = e.target.value;
              setRemark(value);
            }}
            fullWidth
            required
            error={!!remarkError}
            helperText={remarkError}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle1" gutterBottom>
            Upload Visit Pictures
          </Typography>
        </Grid>

        {/* Mandatory Visit Picture */}
        <Grid item xs={12}>
          <Button
            variant="outlined"
            component="label"
            fullWidth
            disabled={loadingMandatory}
            sx={{
              width: "60%",
              mt: 1,
              textTransform: "none",
              border: "2px dashed black",
              backgroundColor: "lightgray",
              "&:hover": { backgroundColor: "gray" },
              cursor: "pointer",
              opacity: 1,
            }}
          >
            {loadingMandatory ? "Uploading..." : "Upload Visit Image1"}{" "}
            <span style={{ color: "red" }}>*</span>
            <input
              type="file"
              accept="image/*"
              hidden
              required
              onChange={async (e) => {
                const file = e.target.files[0];
                if (file) {
                  setLoadingMandatory(true);
                  try {
                    const compressedFile = await imageCompression(file, {
                      maxSizeMB: 2,
                      maxWidthOrHeight: 1024,
                      useWebWorker: true,
                    });

                    const extension = file.name.split(".").pop();
                    const uniqueName = `img_${Date.now()}.${extension}`;
                    const finalFile = new File([compressedFile], uniqueName, {
                      type: compressedFile.type,
                      lastModified: Date.now(),
                    });

                    setVisitPictureMandatory(finalFile);
                    setPreviewUrl(URL.createObjectURL(finalFile));
                  } catch (error) {
                    console.error("Image compression failed:", error);
                  } finally {
                    setLoadingMandatory(false);
                  }
                }
              }}
            />
          </Button>

          {visitpictureMandatory && (
            <>
              <Typography variant="body2" mt={1}>
                {visitpictureMandatory.name}
              </Typography>
              {previewUrl && (
                <Box mt={1} position="relative" display="inline-block">
                  <img
                    src={previewUrl}
                    alt="Visit Preview"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "200px",
                      borderRadius: "8px",
                      marginTop: "8px",
                      border: "1px solid #ccc",
                    }}
                  />
                  <IconButton
                    size="small"
                    onClick={() => {
                      setVisitPictureMandatory(null);
                      setPreviewUrl("");
                    }}
                    sx={{
                      position: "absolute",
                      top: 4,
                      right: 4,
                      backgroundColor: "white",
                      "&:hover": { backgroundColor: "#f8d7da" },
                    }}
                  >
                    <DeleteIcon fontSize="small" color="error" />
                  </IconButton>
                </Box>
              )}
            </>
          )}
        </Grid>

        {/* Optional Visit Picture */}
        <Grid item xs={12}>
          <Button
            variant="outlined"
            component="label"
            fullWidth
            disabled={loadingOptional}
            sx={{
              width: "60%",
              mt: 1,
              textTransform: "none",
              border: "2px dashed black",
              backgroundColor: "lightgray",
              "&:hover": { backgroundColor: "gray" },
              cursor: "pointer",
              opacity: 1,
            }}
          >
            {loadingOptional ? "Uploading..." : "Upload Visit Image2"}
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={async (e) => {
                const file = e.target.files[0];
                if (file) {
                  setLoadingOptional(true);
                  try {
                    const compressedFile = await imageCompression(file, {
                      maxSizeMB: 2,
                      maxWidthOrHeight: 1024,
                      useWebWorker: true,
                    });

                    const extension = file.name.split(".").pop();
                    const uniqueName = `img_${Date.now()}.${extension}`;
                    const finalFile = new File([compressedFile], uniqueName, {
                      type: compressedFile.type,
                      lastModified: Date.now(),
                    });

                    setTravelPictureOptional(finalFile);
                    setPreviewOptionalUrl(URL.createObjectURL(finalFile));
                  } catch (err) {
                    console.error("Image compression failed:", err);
                  } finally {
                    setLoadingOptional(false);
                  }
                }
              }}
            />
          </Button>

          {travelPictureOptional && (
            <>
              <Typography variant="body2" mt={1}>
                {travelPictureOptional.name}
              </Typography>
              {previewOptionalUrl && (
                <Box mt={1} position="relative" display="inline-block">
                  <img
                    src={previewOptionalUrl}
                    alt="Visit Preview 2"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "200px",
                      borderRadius: "8px",
                      marginTop: "8px",
                      border: "1px solid #ccc",
                    }}
                  />
                  <IconButton
                    size="small"
                    onClick={() => {
                      setTravelPictureOptional(null);
                      setPreviewOptionalUrl("");
                    }}
                    sx={{
                      position: "absolute",
                      top: 4,
                      right: 4,
                      backgroundColor: "white",
                      "&:hover": { backgroundColor: "#f8d7da" },
                    }}
                  >
                    <DeleteIcon fontSize="small" color="error" />
                  </IconButton>
                </Box>
              )}
            </>
          )}
        </Grid>

        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={isTravelSubmitting}
          >
            {isTravelSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </Grid>
      </Grid>
    </>
  );
}

export default FarmVisitFormComponent;
